export const SET_STYLE_PARAMS = 'styleParams/SET';

export const setStyleParams = (payload) => (dispatch) => {
  dispatch({ type: SET_STYLE_PARAMS, payload });
  return Promise.resolve();
};
